import axios from "axios";
import { apiUrl } from "./const";
import { clearToken, getLiveToken } from "./auth";
import store from "../redux/store";
import { LOG_OUT } from "../redux/types";

export const api = axios.create({
  baseURL: `${apiUrl}api`,
  headers: {
    "Content-type": "application/json",
  },
});

const endSession = () => {
  clearToken();
  if (store.getState().user.isLoggedIn) store.dispatch({ type: LOG_OUT });
};

api.interceptors.request.use((config) => {
  // Callers may pass their own bearer (e.g. validating a session on startup).
  if (config.headers.Authorization) return config;
  const token = getLiveToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (store.getState().user.isLoggedIn) {
    // The token expired while the tab was open; stop showing a signed-in UI.
    endSession();
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 401 on a request that carried a bearer means the server no longer accepts this
    // session (expired, password changed, banned) — drop it instead of failing silently.
    if (error?.response?.status === 401 && error.config?.headers?.Authorization) endSession();
    return Promise.reject(error);
  }
);

export default api;
